import React from 'react';
import { TbTruckDelivery } from 'react-icons/tb';
import '../styles/components/TopBar.scss';

const TopBar = () => {
  return (
    <div className="Topbar">
      <p>
        <TbTruckDelivery className="Topbar__icon" aria-hidden="true" />
        Atención personalizada y envíos a toda Colombia
      </p>
    </div>
  );
};

export default TopBar;
